import React from 'react';
import { CSVLink } from 'react-csv';
import { ExportOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useIntl } from 'react-intl';
import { BrandData, InviteCodeData } from '../../../@types';

type Props = {
  data: InviteCodeData[] | null;
  circleCode?: string;
  brands: BrandData[] | null;
};

const buildDeeplink = (webAppDomain?: string, key?: string) => {
  if (!webAppDomain || !key) return '';
  const domain = webAppDomain.startsWith('http')
    ? webAppDomain
    : `https://${webAppDomain}`;
  return `${domain}/circle/join/?id=${encodeURIComponent(key)}`;
};

const ExportInviteCodesCSV: React.FC<Props> = ({
  data,
  circleCode,
  brands,
}) => {
  const intl = useIntl();

  if (!data?.length) return null;

  const headers = [
    {
      label: intl.formatMessage({
        id: 'fleetadmin.circle.inviteCodes.keyColumn',
        defaultMessage: 'Key',
      }),
      key: 'key',
    },
    {
      label: intl.formatMessage({
        id: 'fleetadmin.circle.inviteCodes.description',
        defaultMessage: 'Description',
      }),
      key: 'description',
    },
    {
      label: intl.formatMessage({
        id: 'fleetadmin.circle.inviteCodes.status',
        defaultMessage: 'Status',
      }),
      key: 'status',
    },
    {
      label: intl.formatMessage({
        id: 'fleetadmin.circle.inviteCodes.link',
        defaultMessage: 'Link',
      }),
      key: 'link',
    },
  ];

  const rows = data.map((code) => {
    const webAppDomain = code.brandId
      ? brands?.find((b) => b.id === code.brandId)?.webAppDomain
      : undefined;
    return {
      key: code.key || '',
      description: code.description || '',
      status: code.status || '',
      link: buildDeeplink(webAppDomain, code.key),
    };
  });

  const filename = `InviteCodes_${circleCode || 'circle'}_${moment().format(
    'YYYY_MM_DD'
  )}.csv`;

  return (
    <CSVLink
      data={rows}
      headers={headers}
      filename={filename}
      className="btn btn-primary"
      style={{ fontSize: 12 }}
      data-testid="InviteCodes-exportCsvBtn"
    >
      <ExportOutlined style={{ marginRight: 3 }} />
      {intl.formatMessage({
        id: 'fleetadmin.circle.inviteCodes.exportCsv',
        defaultMessage: 'Export (CSV)',
      })}
    </CSVLink>
  );
};

export default ExportInviteCodesCSV;
